import { Survey } from "Models";
import {SentactFeedbackHttpError} from "util/SentactFeedbackHttpError.js";
import { get } from "api/action/base.js";
import {getErrorMessage} from "util/ErrorCodes";

const getSurvey = (
    id,
    params={},
) => {
    return get('survey-links/' + id, params)
        .then(data => Survey(data))
        .catch(error => {
            throw new SentactFeedbackHttpError(getErrorMessage(error.code), error.code, error);
        });
}

export default getSurvey;
